export default __webpack_public_path__ + "static/char-s-20-zh-Hans-311ba9ee6c14bb748e169866bb1ec9fc.webp";